import { UseQueryResult } from '@tanstack/react-query';
import { Option } from 'baseui/select';
import { ApiError, ApiResult } from 'common/repositories/common.model';

export interface UseGenerateSelectProps<T> {
  value?: string;
  query: UseQueryResult<ApiResult<T[]>, ApiError>;
  transformer: (data: T) => Option;
}

export default function useGenerateSelectProps<T>(
  props: UseGenerateSelectProps<T>,
) {
  const { query, value, transformer } = props;
  const { data } = query;

  const options = (data?.data || []).map((employee) => transformer(employee));
  const _value = options.find((employee) => employee.id === value);

  return {
    value: _value ? [_value] : undefined,
    options,
  };
}
